var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignBrief(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.77778C0 1.24349 1.24349 0 2.77778 0H9.72222V5.55556C9.72222 6.32378 10.3429 6.94444 11.1111 6.94444H16.6667V8.61979C13.4592 9.52691 11.1111 12.474 11.1111 15.9722C11.1111 18.5373 12.3741 20.803 14.3099 22.1918C14.1753 22.2092 14.0321 22.2222 13.8889 22.2222H2.77778C1.24349 22.2222 0 20.9766 0 19.4444V2.77778ZM11.1111 5.55556V0L16.6667 5.55556H11.1111ZM25 15.9722C25 19.4227 22.2005 22.2222 18.75 22.2222C15.2995 22.2222 12.5 19.4227 12.5 15.9722C12.5 12.5217 15.2995 9.72222 18.75 9.72222C22.2005 9.72222 25 12.5217 25 15.9722ZM20.6901 14.0929L18.0556 16.7274L16.8099 15.4818C16.5408 15.2083 16.0981 15.2083 15.829 15.4818C15.5556 15.7509 15.5556 16.1936 15.829 16.4627L17.5651 18.1988C17.8342 18.4722 18.2769 18.4722 18.546 18.1988L21.671 15.0738C21.9444 14.8047 21.9444 14.362 21.671 14.0929C21.4019 13.8194 20.9592 13.8194 20.6901 14.0929Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignBrief);
export default __webpack_public_path__ + "static/media/campaign_brief.e81b06eb.svg";
export { ForwardRef as ReactComponent };